module.exports = __webpack_public_path__ + "img/audio_cd.df1f0dab.png";